module.exports = __webpack_public_path__ + "images/backgrounds/snow/small.2b2295a578d6655c6515.jpg";